export default "__VITE_ASSET__676a5d7b__"